// Prepare during the click that joins the call so the browser allows the alert sound.
export function createAttentionSound() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return null;
  try {
    const context = new AudioContext();
    context.resume().catch(() => {});
    return context;
  } catch (error) { return null; }
}

export function playAttentionSound(context) {
  if (!context || context.state === 'closed') return;
  context.resume().then(() => {
    if (context.state !== 'running') return;
    // Two short tones; local playback only, outside the recorded microphone stream.
    [0, 0.3].forEach(delay => {
      const start = context.currentTime + delay;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(delay ? 880 : 660, start);
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.18, start + 0.02);
      gain.gain.linearRampToValueAtTime(0, start + 0.22);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
      oscillator.start(start);
      oscillator.stop(start + 0.24);
    });
  }).catch(() => {});
}
